 
 
 
 
 
 
define([
    './addressModel',
    './poiModel',
    './searchModel',
    '../../services/utils'
], function(
    AddressModel,
    PoiModel,
    SearchModel,
    utils
) {
    'use strict';

    var LowBandwidthSearchModel = function(json) {
        this.type = json.tp;
        this.entityType = json.etp;

        this.address = new AddressModel({
            freeformAddress: json.a2
        });

        this.position = utils.convertToLatLng(json.ps.split(' '));

        this.poi = new PoiModel({
            name:  json.nm,
            phone: json.ph,
            categories: json.ct,
            classifications: json.cst.map(function(classification) {
                return {
                    code: classification.cd,
                    names: classification.ns.map(function(name) {
                        return {
                            nameLocale: name.nl,
                            name: name.na
                        };
                    })
                };
            })
        });

        return this;
    };
    LowBandwidthSearchModel.prototype = Object.create(SearchModel.prototype);
    LowBandwidthSearchModel.prototype.constructor = LowBandwidthSearchModel;

    LowBandwidthSearchModel.prototype.simplify = function() {
        return {
            tp: this.type,
            etp: this.entityType,
            a2: this.address.freeformAddress,
            ps: this.position.lat + ' ' + this.position.lng,
            nm: this.poi.name,
            ph: this.poi.phone,
            ct: this.poi.categories,
            cst: this.poi.classifications.map(function(classification) {
                return {
                    cd: classification.code,
                    ns: classification.names.map(function(name) {
                        return {
                            nl: name.nameLocale,
                            na: name.name
                        };
                    })
                };
            })
        };
    };

    return LowBandwidthSearchModel;

});



// WEBPACK FOOTER //
// ./model/search/lowBandwidthSearchModel.js